import React from 'react';
import * as Sentry from '@sentry/react';

import { Provider } from 'react-redux';
import thunk from 'redux-thunk';

import { configureStore } from '@eb/redux-configure-store';
import { middleware as analyticsMiddleware } from '@eb/site-analytics';

import { BasePage } from '../base';
import { OverlayProvider } from '../../context/Overlay';

import withCookieHeaderHeight from '../../components/withCookieHeaderHeight';
import EnhancedSearchConsumerHeader from '../../components/EnhancedSearchConsumerHeader';
import { getSearchPageHeaderOffset } from '../../components/ConsumerHeader/utils';
import ConfirmationOverlay from '../../components/ConfirmationOverlay/ConfirmationOverlay';

import reducer from '../../SearchApp/reducers';
import { getInitialData } from '../../SearchApp/reducers/utils';

import { SearchBaseContainer } from './containers';
import '../../SearchApp/app.scss';

export class SearchPage extends React.Component {
    constructor(props) {
        super(props);

        // creates a store w/ Redux logging defaulted in development environment
        // also adds `redux-thunk` middleware by default for async actions
        this._store = configureStore({
            reducer,
            initialState: getInitialData(props),
            middleware: [thunk, analyticsMiddleware(props)],
        });

        this.state = {
            headerOffset: getSearchPageHeaderOffset(props.cookieHeaderHeight),
        };
    }

    componentDidMount() {
        const { cookieHeaderHeight } = this.props;

        Sentry.setTag('sub_app', 'search');

        this.setState({
            headerOffset: getSearchPageHeaderOffset(cookieHeaderHeight),
        });
    }

    componentDidUpdate(prevProps) {
        if (this.props.cookieHeaderHeight !== prevProps.cookieHeaderHeight) {
            this.setState({
                headerOffset: getSearchPageHeaderOffset(
                    this.props.cookieHeaderHeight,
                ),
            });
        }
    }

    render() {
        return (
            <Provider store={this._store}>
                <OverlayProvider>
                    <BasePage
                        {...this.props}
                        isSearchPage={true}
                        structureHeader={EnhancedSearchConsumerHeader}
                    >
                        <ConfirmationOverlay />
                        <div
                            className="feed-search-page"
                            style={{ paddingTop: this.state.headerOffset }}
                        >
                            <SearchBaseContainer {...this.props} />
                        </div>
                    </BasePage>
                </OverlayProvider>
            </Provider>
        );
    }
}

export default withCookieHeaderHeight(SearchPage);
